<template>
  <b-list-group-item
    :id="`vehicle-${vehicleId}`"
    :title="!isVideoOnline ? $t('trackVideo.cantReachVideoOffline') : ''"
    class="mc-sidebar-liveview_list_fleet_container"
    :class="{ 'video-offline': !isVideoOnline, selected: getChannelModel.length > 0 }"
  >
    <div class="mc-sidebar-liveview_list-fleet-detail-wrapper">
      <div
        class="mc-trackvision-live-streaming__list-item-header"
        :class="{ 'info-hide': !isShowDetail }"
        :title="
          !isVideoOnline ? $t('trackVideo.cantReachVideoOffline') : getTitleTooltipClickVehicle
        "
        @click="isVideoOnline ? clickVehicle() : undefined"
      >
        <div class="clearfix mc-sidebar-liveview_list-fleet-top-wrapper">
          <span
            v-b-tooltip.hover
            class="mc-trackvision-sidebar__license-plate"
            :class="{
              'pull-left': true,
            }"
          >
            {{ licensePlate }}
          </span>
          <div class="mc-sidebar-liveview_list-fleet-top-badge-wrapper d-flex align-items-center">
            <i
              v-b-tooltip.hover
              class="mc-fa icon-fill_car mc-trackvision-live-streaming__video-status-icon"
              :class="{
                moving: calculatedMotionStatus === 'M',
                idle: calculatedMotionStatus === 'I',
                parking: calculatedMotionStatus === 'P',
                offline: calculatedMotionStatus === 'O' || calculatedMotionStatus === 'U',
                assisted: calculatedMotionStatus === 'A',
              }"
              :title="getTitleTooltipMotionStatus"
            />
            <VideoStatusBadge :isOnline="isVideoOnline" />
          </div>
        </div>

        <div v-show="isShowDetail" class="">
          <div
            v-if="$store.state.video.fleetListDisplay.label_hull && hullNo"
            class="mc-sidebar-liveview__list-fleet-showhide-wrapper"
          >
            <span>
              <i class="mc-fa icon-outline_license-general"></i>
              {{ hullNo }}
            </span>
          </div>
          <div class="mc-sidebar-liveview__list-fleet-showhide-wrapper">
            <span v-if="$store.state.video.fleetListDisplay.label_classification">
              <i class="mc-fa icon-outline_bus"></i>
              <template
                v-if="$store.state.video.fleetListDisplay.classification_type == 'category'"
              >
                {{ vehicleCategory ? vehicleCategory : $t('global.text.noCategory') }}
              </template>
              <template
                v-else-if="$store.state.video.fleetListDisplay.classification_type == 'type'"
              >
                {{ vehicleType }}
              </template>
              <template v-else>{{ manufacturer }}</template>
            </span>
            <span v-if="$store.state.video.fleetListDisplay.label_driver">
              <i class="mc-fa icon-outline_person"></i>
              {{ driver ? driver : $t('global.text.noDriver') }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="mc-trackvision-live-streaming__bottom-action-wrapper mc-sidebar-liveview_list-fleet-top-wrapper"
      >
        <div class="mc-trackvision-live-streaming__multiselect-camera-wrapper">
          <div class="mc-trackvision-live-streaming__multiselect-close-wrapper">
            <i
              v-if="playlistModel.length > 0"
              class="mc-fa icon-fill_close-circle"
              @click="onClickClearIconCamera"
            />
          </div>
          <Multiselect
            :value="playlistModel"
            :options="channelOptions"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :searchable="false"
            label="text"
            track-by="value"
            :disabled="!isVideoOnline"
            :class="'formulate-input-element input-md mc-trackvision-live-streaming__multiselect-camera'"
            @select="onSelectCamera($event)"
            @remove="onRemoveCamera($event)"
          >
            <template #placeholder>
              <span>
                {{
                  isVideoOnline
                    ? $t('global.form.select') + ' ' + $t('trackVideo.camera')
                    : $t('trackVideo.allCameraOffline')
                }}
              </span>
            </template>

            <template #selection="props">
              <span class="mc-trackvision-live-streaming__label-selected">
                {{ getLabelMultiselect(props.values) }}
              </span>
            </template>
          </Multiselect>
        </div>
        <div class="mc-trackvision-live-streaming__bottom-action-divider"></div>
        <template
          v-if="
            hasAccess(['b3f-two-way-communication:read']) &&
            (deviceType === 'bsj' || deviceType === 'vss-howen' || deviceType === 'jc')
          "
        >
          <b-button
            v-if="!vehicleIdsCallActive.includes(vehicleId)"
            v-b-tooltip.hover
            class="mc-sidebar-liveview_button-video-play mc-trackvision-live-streaming__button-call"
            :class="{
              'call-not-available': deviceType === 'jc',
              disabled:
                (vehicleIdsCallActive.length >= $store.state.voip.maxCall &&
                  !vehicleIdsCallActive.includes(vehicleId)) ||
                !isVideoOnline ||
                $store.state.voip.isBroadcastActive,
            }"
            :title="
              deviceType === 'jc'
                ? $t('trackVideo.callDriverNotAvailable')
                : $t('trackVideo.callDriver')
            "
            @click="handleClickStartCall"
          >
            <i class="mc-fa icon-outline_phone"></i>
          </b-button>
          <b-button
            v-if="vehicleIdsCallActive.includes(vehicleId)"
            v-b-tooltip.hover
            class="mc-sidebar-liveview_button-video-play active"
            :title="$t('trackVideo.endCall')"
            :class="{ disabled: !isVideoOnline }"
            @click="handleClickEndCall"
          >
            <i class="mc-fa icon-outline_phone-off"></i>
          </b-button>
        </template>
        <b-button
          v-b-tooltip.hover
          :title="$t('trackVideo.videoHistory')"
          class="mc-sidebar-liveview_button-video-play"
          :disabled="!isVideoOnline"
          @click="handleClickVideoHistory"
        >
          <i class="mc-fa icon-outline_video-history"></i>
        </b-button>
      </div>
    </div>
  </b-list-group-item>
</template>

<script>
import { MixPanel } from '@/mixin/mixpanel'
import Multiselect from 'vue-multiselect'
import { v4 as uuidv4 } from 'uuid'
import VideoStatusBadge from '@/components/VideoStatusBadge.vue'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'

export default {
  name: 'FleetItemStreaming',
  components: {
    Multiselect,
    VideoStatusBadge,
  },
  mixins: [MixPanel, Helper],
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    hullNo: {
      type: String,
      required: false,
      default: '',
    },
    vehicleCategory: {
      type: String,
      required: false,
      default: '',
    },
    vehicleType: {
      type: String,
      required: false,
      default: '',
    },
    manufacturer: {
      type: String,
      required: false,
      default: '',
    },
    driver: {
      type: String,
      required: false,
      default: '',
    },
    calculatedMotionStatus: {
      type: String,
      required: true,
    },
    vehicleId: {
      type: Number,
      required: true,
    },
    imei: {
      type: String,
      required: true,
    },
    deviceCode: {
      type: Number,
      required: true,
    },
    statusText: {
      type: String,
      required: true,
    },
    engineOn: {
      type: Boolean,
      required: true,
    },
    lastReceive: {
      type: String,
      required: true,
    },
    streamingEndpoint: {
      type: String, // trackvision_indo | trackvision_default
      required: true,
    },
    isVideoOnline: {
      type: Boolean,
      required: true,
    },
    isShowDetail: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      playlistModel: [],
    }
  },
  computed: {
    ...mapGetters('voip', ['vehicleIdsCallActive']),
    ...mapGetters('identity', ['getFeatureFlagValue']),
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    deviceType() {
      return this.getDeviceType(this.deviceCode)
    },
    countOfCamera() {
      return this.statusText.split(',').length
    },
    getLabelMultiselect() {
      return (values) => {
        values = values.filter((item) => item.value !== 'all').map((item) => item.text)
        return values.join(', ')
      }
    },
    allOption() {
      return {
        text: this.$t('global.filter.all') + ' ' + this.$t('trackVideo.camera'),
        value: 'all',
      }
    },
    channelOptions() {
      const optionsStatusText = this.statusText.split(',').map((val, index) => ({
        text: this.$t('trackVideo.camera') + ' ' + (index + 1),
        value: this.vehicleId + ':' + val,
      }))
      return [this.allOption, ...optionsStatusText]
    },
    getTitleTooltipClickVehicle() {
      const isAllCameraPlay = this.getChannelModel.length === this.countOfCamera
      if (isAllCameraPlay) {
        return this.$t('trackVideo.clickForStopStreaming')
      } else {
        return this.$t('trackVideo.clickForStreaming')
      }
    },
    getTitleTooltipMotionStatus() {
      if (this.calculatedMotionStatus === 'M') {
        return this.$t('trackVideo.vehicleMoving')
      } else if (this.calculatedMotionStatus === 'I') {
        return this.$t('trackVideo.vehicleIdle')
      } else if (this.calculatedMotionStatus === 'P') {
        return this.$t('trackVideo.vehicleParking')
      } else if (this.calculatedMotionStatus === 'A') {
        return this.$t('trackVideo.vehicleAssisted')
      } else if (this.calculatedMotionStatus === 'U' || this.calculatedMotionStatus === 'O') {
        return this.$t('trackVideo.vehicleOffline')
      }
      return ''
    },
    getChannelModel() {
      return this.playlistModel.filter((item) => item.value !== 'all')
    },
    getChannelListOptions() {
      return this.channelOptions.filter((item) => item.value !== 'all')
    },
    isUsingWsFlv() {
      const featureHubWsFlvCompanyId = this.getFeatureFlagValue('trackvision_list_company_ws_flv')
      if (featureHubWsFlvCompanyId.length === 0) return false
      if (this.getDeviceType(this.deviceCode) === 'jc') {
        return false
      }
      return featureHubWsFlvCompanyId.includes(this.$store.state.identity.whoami?.companyId)
    },
  },
  async mounted() {
    const playlist = this.$store.state.video.playlist
    const playlistModel = this.channelOptions.filter((item) =>
      playlist.some((pl) => pl.id === item.value)
    )
    // check if all camera is selected
    if (playlistModel.length === this.countOfCamera) {
      playlistModel.push(this.allOption)
    }
    this.playlistModel = playlistModel
    await this.$nextTick()
  },
  methods: {
    clickVehicle() {
      this.$emit('resetQueryParamsVehicleId')
      const isAllCameraPlay = this.getChannelModel.length === this.countOfCamera
      if (isAllCameraPlay) {
        this.handleRemoveAllChannel()
      } else {
        this.handleSelectAllChanel()
      }
    },
    onClickClearIconCamera() {
      this.$emit('resetQueryParamsVehicleId')
      this.track('Unselect Stream: Stop Video Streaming', {
        camera: 'all',
      })
      this.handleRemoveAllChannel()
    },
    async handleSelectSpecificChannel(values) {
      const selected = { ...values, uid: uuidv4() }
      this.playlistModel.push(selected)
      await this.$nextTick()
      const modelCamera = this.getChannelModel
      const allCameraSelected = this.countOfCamera === modelCamera.length
      if (allCameraSelected) {
        this.playlistModel.push(this.allOption)
      }

      const { channelNotSent } = await this.$store.dispatch('video/handlePlayStreaming', {
        newChannel: [selected],
        streamingEndpoint: this.streamingEndpoint,
        usingWsFlv: this.isUsingWsFlv,
        dataVehicle: {
          vehicleId: this.vehicleId,
          imei: this.imei,
          deviceCode: this.deviceCode,
        },
      })
      if (channelNotSent.length > 0) {
        this.playlistModel = this.playlistModel.filter((item) => {
          const arr = item.value.split(':')
          const ch = this.deviceType === 'jc' ? (parseInt(arr[1]) + 1).toString() : arr[1]
          return !channelNotSent.includes(ch) && item.value !== 'all'
        })
        this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
      }
      this.$forceUpdate()
      this.$store.commit('video/setLastClosedPlaylist', null)
      this.$store.dispatch('video/handleAddPlaylistVehicle', {
        vehicleId: this.vehicleId,
        deviceCode: this.deviceCode,
        playlistModel: this.getChannelModel,
        licensePlate: this.licensePlate,
        calculatedMotionStatus: this.calculatedMotionStatus,
        imei: this.imei,
        driver: this.driver,
        statusText: this.statusText,
        streamingEndpoint: this.streamingEndpoint,
        usingWsFlv: this.isUsingWsFlv,
      })
    },
    async handleSelectAllChanel() {
      const prevChannel = [...this.getChannelModel]
      const newChannel = this.getChannelListOptions
        .filter((item) => !prevChannel.some((prevItem) => prevItem.value === item.value))
        .map((item) => ({ ...item, uid: uuidv4() }))
      this.playlistModel = [this.allOption, ...prevChannel, ...newChannel]
      await this.$nextTick()
      const isJc = this.deviceType === 'jc'

      const { channelNotSent } = await this.$store.dispatch('video/handlePlayStreaming', {
        newChannel,
        streamingEndpoint: this.streamingEndpoint,
        usingWsFlv: this.isUsingWsFlv,
        dataVehicle: {
          vehicleId: this.vehicleId,
          imei: this.imei,
          deviceCode: this.deviceCode,
        },
      })
      if (channelNotSent.length > 0) {
        this.playlistModel = this.playlistModel.filter((item) => {
          const arr = item.value.split(':')
          const ch = isJc ? (parseInt(arr[1]) + 1).toString() : arr[1]
          return !channelNotSent.includes(ch) && item.value !== 'all'
        })
        this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
      }
      this.$forceUpdate()
      this.$store.commit('video/setLastClosedPlaylist', null)
      this.$store.dispatch('video/handleAddPlaylistVehicle', {
        vehicleId: this.vehicleId,
        deviceCode: this.deviceCode,
        playlistModel: this.getChannelModel,
        licensePlate: this.licensePlate,
        calculatedMotionStatus: this.calculatedMotionStatus,
        imei: this.imei,
        driver: this.driver,
        statusText: this.statusText,
        streamingEndpoint: this.streamingEndpoint,
        usingWsFlv: this.isUsingWsFlv,
      })
    },
    onSelectCamera(values) {
      this.$emit('resetQueryParamsVehicleId')
      if (values.value === 'all') {
        this.track('Select Stream: Play Video Streaming', {
          camera: 'all',
        })
        this.handleSelectAllChanel()
      } else {
        this.track('Select Stream: Play Video Streaming', {
          camera: Number(values.text.split(' ')[1]),
        })
        this.handleSelectSpecificChannel(values)
      }
    },
    handleRemoveSpecificChannel(values) {
      const index = this.playlistModel.findIndex((item) => item.value === values.value)
      if (index !== -1) {
        this.playlistModel.splice(index, 1)
        this.playlistModel = this.playlistModel.filter((item) => item.value !== 'all')
      }
      this.$store.dispatch('video/handleRemovePlaylistVehicle', {
        playlistIdsRemoved: [values.value],
      })
    },
    async handleRemoveAllChannel() {
      this.playlistModel = []
      this.$store.commit('video/setLastClosedPlaylist', null)
      await this.$nextTick()
      const playlistIdsRemoved = this.getChannelListOptions.map((item) => item.value)
      this.$store.dispatch('video/handleRemovePlaylistVehicle', {
        playlistIdsRemoved,
      })
      this.$forceUpdate()
    },
    onRemoveCamera(values) {
      this.$emit('resetQueryParamsVehicleId')
      if (values.value === 'all') {
        this.track('Unselect Stream: Stop Video Streaming', {
          camera: 'all',
        })
        this.handleRemoveAllChannel()
      } else {
        this.track('Unselect Stream: Stop Video Streaming', {
          camera: Number(values.text.split(' ')[1]),
        })
        this.handleRemoveSpecificChannel(values)
      }
    },
    handleClickStartCall() {
      if (!this.isVideoOnline) return this.$mcToast.error(this.$t('trackVideo.deviceUnreachable'))
      this.track('VoIP Admin make a call')
      this.$store.commit('voip/setIsTwoWayActive', true)
      this.$store.dispatch('voip/startNewCall', {
        dataNewCall: {
          vehicleId: this.vehicleId,
          licensePlate: this.licensePlate,
          driver: this.driver,
          imei: this.imei,
          deviceType: this.getDeviceType(this.deviceCode),
          isDebugBroadcast: false,
        },
      })
    },
    handleClickEndCall() {
      this.$store.dispatch('voip/endCall', { vehicleId: this.vehicleId })
    },
    goToHistoryTrackvision() {
      if (this.hasAccess(['b3u-trackvision-video-history-v2:read'])) {
        this.$router.push({
          name: 'Video History 2 Trackvision',
          query: { vehicleId: this.vehicleId },
        })
      } else {
        this.$router.push({
          name: 'Video History Trackvision',
          query: { vehicleId: this.vehicleId },
        })
      }
      this.track('Open Trackvision Video History from Live Streaming')
    },
    goToHistoryOld() {
      const payload = {
        licensePlate: this.licensePlate,
        vehicleType: this.vehicleType,
        vehicleCategory: this.vehicleCategory,
        imei: this.imei,
        deviceName: this.getDeviceType(this.deviceCode),
        id: this.vehicleId,
      }

      this.$store.commit('vehicle/setVehicleDetail', payload)
      this.track('Open Video History')
      const pathName = window.location.pathname.split('/')[1]

      this.$router.push({
        name:
          pathName === 'live-streaming' ? 'Video History Trackvision Download' : 'Video History 3',
        params: { vehicleId: this.vehicleId, entryPoint: 'Sidebar' },
      })
    },
    handleClickVideoHistory() {
      const path = window.location.pathname.split('/')
      const isFromMenuTrackvision = path[1] === 'live-streaming'
      if (isFromMenuTrackvision) {
        this.goToHistoryTrackvision()
      } else {
        this.goToHistoryOld()
      }
    },
    /**
     *
     * @param playlistId format {vehicleId}:{channel}
     */
    handleClosePlaylist(playlistId) {
      this.handleRemoveSpecificChannel({ value: playlistId })
    },
  },
}
</script>
